export const TOR_PERIOD_OPTIONS = Array.from({ length: 13 }, (_, i) => ({ label: i + 1, value: i + 1 }));
